import type { ReactNode } from 'react'

export function Message({
    from,
    children,
    wide = false,
}: {
    from: 'bot' | 'user'
    children: ReactNode
    wide?: boolean
}) {
    const isBot = from === 'bot'
    return (
        <div
            className={`flex w-full ${isBot ? 'justify-start' : 'justify-end'}`}>
            <div
                className={`rounded-md px-3.5 py-2.5 text-sm leading-relaxed whitespace-pre-wrap ${
                    wide ? 'max-w-[92%]' : 'max-w-[80%]'
                } ${
                    isBot
                        ? 'border-border bg-card text-foreground rounded-bl-sm border'
                        : 'bg-primary text-primary-foreground rounded-br-sm'
                }`}>
                {children}
            </div>
        </div>
    )
}
